import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

import { ReactComponent as SyncComponent } from 'assets/icons/Sync.svg';

const Sync = ({ sx, fontSize = 'large', ...props }: SvgIconProps): React.ReactElement => (
  <SvgIcon
    component={SyncComponent}
    viewBox="0 0 68 55"
    fontSize={fontSize}
    sx={{
      // Override Material-UI's default icon styling to preserve original SVG appearance
      color: 'transparent', // Remove default fill color
      '& svg': {
        fill: 'none', // Ensure no fill is applied
        stroke: '#9E9E9E', // Use the original stroke color from the SVG
        strokeWidth: 3, // Match the original stroke width
      },
      ...sx, // Allow custom styles to override if needed
    }}
    {...props}
  />
);

export default Sync;
